import { useEffect, useState } from "react";

// Listado paginado desde el servidor. `fetcher({ page, pageSize })` debe devolver una respuesta axios
// con { items, total, ...extras }; los extras quedan en `datos`. `deps` son filtros extra que, al cambiar, vuelven a consultar (la página se reinicia desde fuera).
export default function usePaginado(fetcher, deps = []) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let activo = true;
    setCargando(true);
    setError("");
    fetcher({ page, pageSize })
      .then(({ data }) => {
        if (!activo) return;
        setItems(data?.items || []);
        setTotal(data?.total || 0);
        setDatos(data || null);
      })
      .catch((e) => {
        if (!activo) return;
        setItems([]);
        setTotal(0);
        setDatos(null);
        setError(e?.response?.data?.error || "No se pudo cargar el listado.");
      })
      .finally(() => { if (activo) setCargando(false); });
    return () => { activo = false; };
    // `fetcher` se vuelve a crear en cada render: lo que dispara la consulta son estos valores.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, version, ...deps]);

  return {
    items, total, datos, error, cargando, page, pageSize, setPage,
    cambiarPageSize: (n) => { setPageSize(n); setPage(1); },
    recargar: (primera = false) => { if (primera) setPage(1); setVersion((v) => v + 1); },
  };
}
